import { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../api/client";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const id = params.get("id");

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (!token || !id) {
    return (
      <div className="container" style={{ maxWidth: 400, padding: "60px 16px", textAlign: "center" }}>
        <h1 style={{ fontSize: 24 }}>Invalid link</h1>
        <p className="muted" style={{ marginBottom: 16 }}>This reset link is invalid or has expired.</p>
        <Link to="/forgot-password" className="btn primary" style={{ padding: "10px 20px" }}>Request new link</Link>
      </div>
    );
  }

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) return setError("Password must be 8+ characters.");
    if (password !== confirm) return setError("Passwords don't match.");
    setBusy(true); setError(null);
    try {
      await api.post("/user/reset-password", { token, id, password });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="container" style={{ maxWidth: 400, padding: "60px 16px" }}>
      <h1 style={{ fontSize: 24, marginBottom: 8 }}>Set new password</h1>

      {done ? (
        <div>
          <p style={{ color: "var(--ok)", marginBottom: 16 }}>Password reset successfully!</p>
          <Link to="/login" className="btn primary" style={{ padding: "10px 20px" }}>Log in</Link>
        </div>
      ) : (
        <div>
          <p className="muted" style={{ marginBottom: 24 }}>Enter your new password below.</p>

          <label className="muted small" style={{ display: "block", marginBottom: 4 }}>New password</label>
          <input className="input" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="Min 8 characters" style={{ width: "100%", marginBottom: 12 }} />

          <label className="muted small" style={{ display: "block", marginBottom: 4 }}>Confirm password</label>
          <input className="input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            placeholder="Type again" style={{ width: "100%", marginBottom: 16 }} />

          {error && <p style={{ color: "var(--bad)", fontSize: 14, marginBottom: 12 }}>{error}</p>}
          <button className="btn primary" onClick={submit} disabled={busy} style={{ width: "100%", padding: 14 }}>
            {busy ? "Resetting…" : "Reset password"}
          </button>
        </div>
      )}
    </div>
  );
}
